import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';
// import bgloginpage from './../../assets/bgloginpage.jpg';
import logo from './../../../assets/global_assets/assets/companyLogo/logoIcon.png'; // ✅ Make sure this logo image exists

function Loader({ loading}) {
  const fullText = "ACCUNITY HR";
  const [index, setIndex] = useState(0);
  const [isDelayed, setIsDelayed] = useState(false);

  useEffect(() => {
    let interval;
    let delayTimer;

    if (loading) {
      interval = setInterval(() => {
        setIndex(prev => (prev + 1) % (fullText.length + 1));
      }, 200);

      delayTimer = setTimeout(() => {
        setIsDelayed(true);
      }, 30000);
    } else {
      document.title = "Accunity HR";
      setIndex(0);
      setIsDelayed(false);
    }

    return () => {
      clearInterval(interval);
      clearTimeout(delayTimer);
    };
  }, [loading]);


  if (!loading) return null;

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backdropFilter: 'blur(6px)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999999,
      }}
    >
        <Box
            sx={{
                backgroundImage: {logo}, // replace with your imported image
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                padding: 4,
                borderRadius: 2,
                boxShadow: 3,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                minWidth: 250,
                backgroundColor: 'white',
                backdropFilter: 'blur(2px)',
              }}
        >
        {/* ✅ Logo above everything */}
        {/* <Box component="img" src={logo} alt="Logo" sx={{ height: 50, mb: 2 }} /> */}

        {/* <CircularProgress color="success" sx={{ height: 50, mb: 2 ,backgroundImage: {logo} }} />

        <Typography
          variant="h6"
          fontFamily="'Courier New', Courier, monospace"
          textAlign="center"
        >
          {fullText.substring(0, index + 1)}
        </Typography> */}
        {/* <Box
        sx={{
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            padding: 4,
            borderRadius: 2,
            boxShadow: 3,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            minWidth: 250,
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            backdropFilter: 'blur(2px)',
        }}
    > */}
        <Box sx={{ position: 'relative', display: 'inline-flex', mb: 2 }}>
            <CircularProgress color="success" sx={{ width: 60, height: 60 }} />
            <Box
            component="img"
            src={logo}
            alt="Logo"
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 30,
                height: 30,
                borderRadius: '50%',
            }}
            />
        </Box>


        {isDelayed ? (
        <Typography
            // variant="body2"
            // color="text.secondary"
            mt={2}
                    textAlign="center"
                >
                    <Typography
                variant="h6"
                fontFamily="'Courier New', Courier, monospace"
                textAlign="center"
            >
                Accunity HR
            </Typography>
            <p
            style={{ fontStyle:"italic" }}>It's taking more time than usual. Please wait...</p>

        </Typography>
        ):(
        <Typography
            variant="h6"
            fontFamily="'Courier New', Courier, monospace"
            textAlign="center"
        >
            {fullText.substring(0, index + 1)}
        </Typography>
        )}
    </Box>
      {/* </Box> */}
    </Box>


  );
}

export default Loader;
